import { IdTutorialFocusElement } from "../IdTutorialFocusElement";
import { IdTutorialStep } from "../IdTutorialStep";
import { selectTutorialConfigData } from "../selectors/selectTutorialConfigData";
export var checkTutorialConstructClickBuyButton = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var _a = selectTutorialConfigData(state), tutorialStepConfig = _a.tutorialStepConfig, nextTutorialStepConfig = _a.nextTutorialStepConfig;
    if (tutorialStepConfig.nextStep !== IdTutorialStep.constructWindmill_clickBuyButton) {
        return undefined;
    }
    var hasFocusId = nextTutorialStepConfig.focusId !== undefined;
    var hasBuildingId = nextTutorialStepConfig.buildingId !== undefined;
    if (!hasBuildingId && !hasFocusId) {
        return undefined;
    }
    if (tutorialStepConfig.focusId === IdTutorialFocusElement.button_building_buy) {
        return undefined;
    }
    return hasFocusId ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/checks/checkTutorialConstructClickBuyButton.ts
// module id = 2484
// module chunks = 3